import {
    type UscFinanceActionsType,
    USC_FINANCE_SET_FAILED,
    USC_FINANCE_SET_INFO,
    USC_FINANCE_SET_QUOTE_ID,
    USC_FINANCE_START_FETCH,
} from "../actions/UscFinanceActions";
import type {
    StockFinancePayload,
    UscFinanceAccessoryType,
    UscFinanceCostType,
    UscFinanceResponseDebugType,
    UscFinanceServiceType,
    UsedFinanceInsurancePayload,
    UsedFinanceInsurancePayloadV2,
} from "../../utils/financeUtils";
import type { UscFinanceInfoType } from "../../../shared-logic/types/UscCommonTypes";

export type UscFinanceReducerType = {
    monthlyPrice: number; // No monthlyPriceFormatted here as DF doesnt have this property either.
    fetching: boolean;
    failed: boolean;
    info: UscFinanceInfoType | null;
    financeQuoteId: string | null;
    accessories: UscFinanceAccessoryType[];
    services: UscFinanceServiceType[];
    costs: UscFinanceCostType[];
    latestPayload: UsedFinanceInsurancePayload | UsedFinanceInsurancePayloadV2 | StockFinancePayload | null;
    latestResponse: UscFinanceResponseDebugType | null; // Used for debugging purposes.
};

export const initialStateUscFinance: UscFinanceReducerType = {
    monthlyPrice: 0,
    fetching: true,
    failed: false,
    info: null,
    financeQuoteId: null,
    accessories: [],
    services: [],
    costs: [],
    latestPayload: null,
    latestResponse: null,
};

const UscFinanceReducer = (
    state: UscFinanceReducerType = initialStateUscFinance,
    action: UscFinanceActionsType,
): UscFinanceReducerType => {
    switch (action.type) {
        case USC_FINANCE_SET_INFO: {
            const { info, financeQuoteId, monthlyPrice, accessories, services, costs, payload, response } = action;
            return {
                ...state,
                latestPayload: payload,
                info,
                financeQuoteId,
                monthlyPrice,
                failed: false,
                fetching: false,
                accessories,
                costs,
                services,
                latestResponse: response,
            };
        }

        case USC_FINANCE_SET_QUOTE_ID: {
            const { financeQuoteId } = action;
            return { ...state, financeQuoteId };
        }

        case USC_FINANCE_SET_FAILED: {
            const { failed, payload } = action;
            return { ...state, failed, latestPayload: payload };
        }

        case USC_FINANCE_START_FETCH: {
            return { ...state, fetching: true, failed: false };
        }

        default:
            return state;
    }
};

export default UscFinanceReducer;
